import React, { useCallback } from 'react'
import { Grid, HandTile, Player } from '../../models'
import GameView from '../game-view'
import Controls from './Controls'

export interface PlayGameViewProps {
    players: Player[]
    grid: Grid
    bagSize: number
    handTiles: HandTile[]
    isMyTurn: boolean
    canPlace: boolean
    canTrade: boolean
    canReset: boolean
    canSubmit: boolean
    onPlace: (x: {row: number, col: number, tileId: number}) => any
    onTakeBack: (x: {tileId: number}) => any
    onTrade: (x: {tileId: number}) => any
    onSubmit: () => any
    onReset: () => any
}

export default function  PlayGameView(props: PlayGameViewProps) {
    const { onPlace, onTakeBack, onTrade, onSubmit, onReset } = props
    const handlePlace = useCallback(({ row, col, tile }) => onPlace({ row, col, tileId: tile.id }), [onPlace])
    const handleTakeBack = useCallback(({ tileId }) => onTakeBack({ tileId }), [onTakeBack])
    const handleTrade = useCallback(({ tileId }) => onTrade({ tileId }), [onTrade])
    const handleReset = useCallback(() => onReset(), [onReset])
    const handleSubmit = useCallback(() => onSubmit(), [onSubmit])


    const controls = (
        <Controls
            bagSize={props.bagSize}
            handTiles={props.handTiles}
            canTrade={props.canTrade}
            canReset={props.canReset}
            canSubmit={props.canSubmit}
            onTakeBack={handleTakeBack}
            onTrade={handleTrade}
            onReset={handleReset}
            onSubmit={handleSubmit}
        />
    )

    return  (
        
        <GameView
            players={props.players}
            grid={props.grid}
            isMyTurn={props.isMyTurn}
            onPlace={handlePlace}
            controls={controls}
        />
    )
}